var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center c-orange mb-5"},[_vm._v("Parabéns!")]),_c('h2',{staticClass:"text-center"},[_vm._v("Você já pode comemorar, seu aplicativo já está disponível para download.")])])
}]

export { render, staticRenderFns }